import {Component, Input, OnInit} from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {ConfService} from '../../conf.service';
import {AppComponent} from '../../app.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {IdletimeoutListenerService} from '../../idletimeout-listener.service';
import {Router} from '@angular/router';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
  selector: 'app-idle-timeout',
  templateUrl: './idle-timeout.component.html',
  styleUrls: ['./idle-timeout.component.scss']
})
export class IdleTimeoutComponent implements OnInit {

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  settingsData: any;
  idleTimeOutConfig: any;
  origIdleTimeOutConfig: any;

  constructor(public platform: LeftpanelComponent,
              public idleTimeoutListenerInstance: IdletimeoutListenerService,
              public router: Router,
              public confPost: ConfService,
              public accountInfoService: AccountInfoService,
              public appComp: AppComponent,
              public dialog: MatDialog) { }

  async ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    if (this.platform.settingsData === null || this.platform.settingsData === undefined) {
      await this.platform.getSettingsData(this.partner, this.account, false);
    }
    this.settingsData = this.platform.settingsData;
    if (this.settingsData && this.settingsData['body'] && this.settingsData['body'] !== undefined && this.settingsData['body'] !== null) {
      for (const environment of this.settingsData['body'][0]['environments']) {
        if (environment['name'] === this.partner) {
          const timeService = environment['services'].filter(element => element.name === 'Time');
          for (const config of timeService[0]['configurations']) {
            if (config && config !== null && config !== undefined) {
              if (config['name'] === 'Idle Timeout') {
                this.idleTimeOutConfig = config;
                this.origIdleTimeOutConfig = JSON.parse(JSON.stringify(this.idleTimeOutConfig));
              }
            }
          }
        }
      }
    }
  }

  patchConfiguration(partner, account, version, entity, id, payload) {
    return new Promise((resolve, reject) => {
      this.platform.patchEntityData(partner, account, version, entity, id, payload).then(resp => {
        resolve('success');
      }, error => {
        reject(error);
      });
    });
  }

  updateIdleTimeoutConfig() {
    if (JSON.stringify(this.origIdleTimeOutConfig) === JSON.stringify(this.idleTimeOutConfig)) {
      this.platform.openSnackBar('There are no changes to update.', 'Error', {
        duration: 10000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    } else {

      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'idletimeout_update_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
        const payloadToSend = {
          actions: response
        };
        this.idleTimeoutListenerInstance.idleTimeoutListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });

      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
      let index = 0;
      for (const env1 of this.settingsData['body'][0]['environments']) {
        if (env1 && env1 !== null && env1 !== undefined) {
          this.confPost.getSettingsV2CRUD(env1['name'], env1['name'], false).subscribe(async response1 => {
            if (response1 && response1['body'] && response1.status === 200) {
              for (const env2 of response1['body'][0]['environments']) {
                if (env2 && env2 !== null && env2 !== undefined) {
                  const timeService = env2['services'].filter(element => element.name === 'Time');
                  if (timeService.length === 0) {
                    env2['services'].push({
                      'name': 'Time',
                      'type': 'time',
                      'configurations': this.idleTimeOutConfig
                    });
                  } else {
                    for (let i = 0; i < timeService[0]['configurations'].length; i++) {
                      const config = timeService[0]['configurations'][i];
                      if (config && config !== null && config !== undefined) {
                        if (config['name'] === 'Idle Timeout') {
                          timeService[0]['configurations'][i] = this.idleTimeOutConfig;
                        }
                      }
                    }
                  }
                }
              }
              await this.patchConfiguration('services', 'services', 'v2', 'settings', response1['body'][0]['id'], response1['body'][0]).then(resp => {
                index += 1;
                if (index === this.settingsData['body'][0]['environments'].length) {
                  this.origIdleTimeOutConfig = JSON.parse(JSON.stringify(this.idleTimeOutConfig));
                  // this.appComp.idleTimeOutConfig = this.idleTimeOutConfig;
                  // if (this.idleTimeOutConfig['is_enabled'] === false) {
                  //   this.appComp.loggedIn.emit(false);
                  // } else {
                  //   this.appComp.loggedIn.emit(true);
                  // }
                  Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'idletimeout_update_success', 'INFO', 200, 'OK', '', this.idleTimeOutConfig, '', this.router.url)).then(res => {
                    const payloadToSend = {
                      actions: res
                    };
                    this.idleTimeoutListenerInstance.idleTimeoutListener.emit({
                      type: 'audit',
                      id: localStorage.getItem('IdOfSession'),
                      payload: payloadToSend
                    });
                  });
                  this.platform.openSnackBar('Configuration updated successfully.', 'Success', {
                    duration: 4000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                  setTimeout(() => {
                    location.reload();
                  }, 1000);
                  loaderDialog.close();
                }
              }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'idletimeout_update_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), this.idleTimeOutConfig, error, this.router.url)).then(res => {
                  const payloadToSend = {
                    actions: res
                  };
                  this.idleTimeoutListenerInstance.idleTimeoutListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                  });
                });
                loaderDialog.close();
              });
            }
          }, error => {
            loaderDialog.close();
          });
        } else {
          loaderDialog.close();
        }
      }
    }
  }
}
